const DEFAULT_PER_PAGE = 50;

const buildCreatedAtFilter = (
  createdAtRanges?: string[] | null,
): string | string[] | undefined => {
  if (!createdAtRanges?.length) return undefined;
  return createdAtRanges.length === 1 ? createdAtRanges[0] : createdAtRanges;
};

export interface IHistoryQueryParams {
  filter?: Record<string, unknown>;
  createdAtRanges?: string[] | null;
  extraParams?: Record<string, string>;
  paginate?: boolean;
  page?: number;
  perPage?: number;
}

export const buildHistoryQueryString = ({
  filter = {},
  createdAtRanges,
  extraParams = {},
  paginate = true,
  page = 1,
  perPage = DEFAULT_PER_PAGE,
}: IHistoryQueryParams): string => {
  const parts: string[] = [];

  if (paginate) {
    parts.push(`_page=${page}`, `_per_page=${perPage}`);
  }

  Object.entries(extraParams).forEach(([key, value]) => {
    parts.push(`${key}=${encodeURIComponent(value)}`);
  });

  const createdAt = buildCreatedAtFilter(createdAtRanges);
  const filterObject = {
    ...filter,
    ...(createdAt !== undefined ? { created_at: createdAt } : {}),
  };

  if (Object.keys(filterObject).length > 0) {
    parts.push(`_filter=${encodeURIComponent(JSON.stringify(filterObject))}`);
  }

  return parts.join('&');
};
